/** @format */
import angular from 'angular';
import _ from 'lodash';
import { localeServiceModule, localizedStringFilterModule } from 'sis-common';
export const courseUnitRealisationNameFilterModule = 'student.common.filters.courseUnitRealisationName';
(function () {
  angular.module(courseUnitRealisationNameFilterModule, [localeServiceModule, localizedStringFilterModule]).filter('courseUnitRealisationName', ["$filter", function ($filter) {
    return function (cur, useFullName, preferredLanguage) {
      if (!cur) {
        return undefined;
      }
      var nameKey = useFullName ? 'fullName' : 'name';
      var name;
      if (preferredLanguage) {
        name = $filter('localizedString')(_.result(cur, nameKey, cur.name), preferredLanguage);
      } else {
        name = $filter('localizedString')(_.result(cur, nameKey, cur.name));
      }
      return name;
    };
  }]);
})();